module.exports = __webpack_public_path__ + "89ad8340295b7fb80303cd6bb2456fca.png";